import { BuildClass, getFileTypeInfoFromMIME, tw } from '../../../../universal';
import { match, matchP, React } from '../../../lib';
import { CustomPDFContainer } from '../../component-pdf-viewer';
import { LoadingSpinnerLarge } from '../loading';
import { XlsxPreview } from './xlsx-preview';
export const NoteAttachment = (props) => {
    const attachment = props.attachment;
    const attachmentGUID = attachment?.FileGUID ?? null;
    const attachmentChecksum = attachment?.Checksum ?? null;
    const hasAttachment = Boolean(attachmentGUID || attachmentChecksum);
    const hostStorage = 'https://storage.trionline.com.au';
    const url = match([attachmentGUID, attachmentChecksum])
        .with([matchP.string, matchP._], ([guid]) => `${hostStorage}/get-v3/${guid}`)
        .with([null, matchP.string], ([, checksum]) => `${hostStorage}/get/${checksum}`)
        .otherwise(() => '');
    const [fileTypeInfo, setFileTypeInfo] = React.useState(getFileTypeInfoFromMIME(attachment?.MimeType ?? ''));
    const [hasCheckedFileInfo, setHasCheckedFileInfo] = React.useState(false);
    React.useEffect(() => {
        if (!hasAttachment || attachment?.MimeType || hasCheckedFileInfo) {
            return;
        }
        fetch(`${url}/`)
            .then(async (res) => res.blob())
            .then(blob => {
            setFileTypeInfo(getFileTypeInfoFromMIME(blob.type));
            setHasCheckedFileInfo(true);
        })
            .catch(console.error);
    }, [attachment?.MimeType, hasAttachment, hasCheckedFileInfo, url]);
    if (!attachment || !hasAttachment) {
        return React.createElement(React.Fragment, null);
    }
    if (!attachment.MimeType && !hasCheckedFileInfo) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    const wrappingClassName = tw `w-full h-full text-center overflow-y-auto`;
    if (fileTypeInfo.type == 'image') {
        return (React.createElement("div", { className: wrappingClassName },
            React.createElement("img", { className: "mx-auto", src: url })));
    }
    if (fileTypeInfo.type == 'video') {
        return (React.createElement("div", { className: wrappingClassName },
            React.createElement("video", { className: "mx-auto", src: url })));
    }
    if (fileTypeInfo.type == 'audio') {
        return (React.createElement("div", { className: wrappingClassName },
            React.createElement("audio", { className: "mx-auto", src: url })));
    }
    if (fileTypeInfo.type == 'pdf') {
        return React.createElement(CustomPDFContainer, { url: url });
    }
    if (fileTypeInfo.type == 'spreadsheet') {
        return (React.createElement(XlsxPreview, { url: url, filename: getAttachmentGeneratedFilename(attachment) }));
    }
    return (React.createElement("div", { className: wrappingClassName },
        React.createElement("a", { href: url, className: BuildClass([
                'w-full p-2',
                'text-blue-600 text-lg',
                'hover:text-red-600 cursor-pointer',
            ]), target: "_blank" }, getAttachmentGeneratedFilename(attachment))));
};
export const getAttachmentGeneratedFilename = (attachment) => {
    const fileTypeInfo = getFileTypeInfoFromMIME(attachment.MimeType);
    return fileTypeInfo.extension ? `attachment.${fileTypeInfo.extension}` : 'attachment';
};
//# sourceMappingURL=attachments.js.map